import React from 'react'
import {ISpace} from '../../../types/uiComponentTypes'

export const Space:ISpace = () => {
  return (
    <div className='flex-grow'></div>
  )
}
